/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ReconciliationMatchMethodV2 =
  | 'None'
  | 'Tid'
  | 'AuthorizationCode'
  | 'Nsu'
  | 'Manual'
  | 'PixAmountAndDate'
  | 'AmountAndDate';

export const ReconciliationMatchMethodV2 = {
  None: 'None' as ReconciliationMatchMethodV2,
  Tid: 'Tid' as ReconciliationMatchMethodV2,
  AuthorizationCode: 'AuthorizationCode' as ReconciliationMatchMethodV2,
  Nsu: 'Nsu' as ReconciliationMatchMethodV2,
  Manual: 'Manual' as ReconciliationMatchMethodV2,
  PixAmountAndDate: 'PixAmountAndDate' as ReconciliationMatchMethodV2,
  AmountAndDate: 'AmountAndDate' as ReconciliationMatchMethodV2,
};
